<script>
import OrganizationSelect from "@/components/navigation/OrganizationSelect.vue";
import NavigationLogo from "@/components/navigation/NavigationLogo.vue";
import tinycolor from "tinycolor2";
import DeveloperTools from "@/components/navigation/DeveloperTools.vue";
import { mapGetters } from 'vuex'
// import Balance from "@/components/navigation/Balance.vue";

export default {
  components: {DeveloperTools, OrganizationSelect, NavigationLogo},
  data: () => ({
    selectedSidebarNavItem: null,
    updateKey: 0,
  }),
  computed: {
    ...mapGetters(['isAdminInAnyOrganization']),
    navigationItems() {
      return [
        {
          id: 'sidebar-link-outbox',
          title: this.$t('navigation.outbox'),
          icon: 'mdi-inbox-arrow-up',
          to: '/orders',
          permissions: [],
          children: [
            {
              id: 'sidebar-link-new-letter',
              title: this.$t('navigation.outbox.new.order'),
              icon: 'mdi-email-fast-outline',
              to: '/upload',
              permissions: []
            },
            {
              id: 'sidebar-link-orders-list',
              title: this.$t('navigation.outbox.orders'),
              icon: 'mdi-card-multiple-outline',
              to: '/orders/list',
              permissions: []
            },
            {
              id: 'sidebar-link-documents-list',
              title: this.$t('navigation.outbox.documents'),
              icon: 'mdi-file-document-multiple-outline',
              to: '/orders/documents',
              permissions: []
            }
          ]
        },
        {
          id: 'sidebar-link-inbox',
          title: this.$t('navigation.inbox'),
          icon: 'mdi-inbox-arrow-down',
          to: '/inbox',
          restriction: () => this.$permissions?.hasInput,
          permissions: []
        },
        {
          id: 'sidebar-link-backoffice',
          title: this.$t('navigation.backoffice'),
          icon: 'mdi-door-closed-lock',
          to: '/backoffice',
          restriction: () => this.$permissions?.hasBackoffice,
          permissions: []
        },
        {
          id: 'sidebar-link-invoices',
          title: this.$t('navigation.invoices'),
          icon: 'mdi-calculator',
          to: '/invoices',
          restriction: () => this.$permissions?.hasCreditAccount,
          permissions: []
        },
        {
          id: 'sidebar-link-settings',
          title: this.$t('navigation.settings'),
          icon: 'mdi-cog-outline',
          to: '/settings',
          permissions: []
        },
        {
          id: 'sidebar-link-my-organizations',
          title: this.$store.getters?.organizations?.length === 1 ||
          this.$store.getters?.organizations?.length === 0
            ? this.$t('navigation.my.organization')
            : this.$t('navigation.my.organizations'),
          icon: 'mdi-domain',
          to: '/my-organizations',
          restriction: () => this.$permissions?.hasInvite || this.isAdminInAnyOrganization,
          permissions: []
        },
        {
          id: 'sidebar-link-reseller-management',
          title: this.$t('navigation.reseller.management'),
          icon: 'mdi-domain',
          to: '/reseller-management',
          restriction: () => this.$permissions?.hasResellerManagement,
          permissions: []
        }
      ];
    }
  },
  watch: {
    '$permissions': {
      handler() {
        setTimeout(() => this.updateKey++, 100);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    tinycolor
  }
}
</script>

<template>
  <v-navigation-drawer
    id="sidebar"
    :key="updateKey"
    :app="!$store.getters.isSidebarExpanded"
    :color="$store.getters.lightTheme.sidebarBackground"
    fixed
    permanent
    :mini-variant="$store.getters.isSidebarExpanded">
    <v-container class="sidebar-logo-container">
      <NavigationLogo :size="$store.getters.isSidebarExpanded ? 'small' : ''"/>
    </v-container>
    <v-divider></v-divider>
    <!--ORGANIZATION SELECT-->
    <v-list
      v-if="$store.getters.hasOrganizations"
      :class="$permissions.hasCreditAccount ? 'pb-0 mb-0' : ''">
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="sidebarLink">mdi-office-building</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          <OrganizationSelect/>
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <!--CREDIT BALANCE-->
    <!--    <v-list-->
    <!--      v-if="$permissions.hasCreditAccount"-->
    <!--      class="pt-0 mt-0">-->
    <!--      <v-list-item>-->
    <!--        <v-list-item-icon>-->
    <!--          <v-icon>mdi-cash</v-icon>-->
    <!--        </v-list-item-icon>-->
    <!--        <v-list-item-title>-->
    <!--          <Balance/>-->
    <!--        </v-list-item-title>-->
    <!--      </v-list-item>-->
    <!--    </v-list>-->
    <v-divider></v-divider>
    <!--NAVIGATION LIST-->
    <v-list>
      <template v-for="(item, index) in navigationItems">
        <template v-if="!item.restriction || item.restriction()">
          <v-list-group
            v-if="item.children"
            :key="index"
            color="sidebarLink"
            :append-icon="selectedSidebarNavItem === index ? 'mdi-chevron-up' : 'mdi-chevron-down'"
            :value="item.id === 'sidebar-link-outbox' ? true : selectedSidebarNavItem === index"
            @click="selectedSidebarNavItem = index">
            <!-- ITEMS WITH CHILDREN-->
            <template #activator>
              <v-list-item :id="item.id" class="no-indent">
                <v-list-item-icon>
                  <v-icon color="sidebarLink">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title :style="`color: ${$vuetify.theme.themes.light.sidebarLink}`">{{
                    item.title
                  }}
                </v-list-item-title>
              </v-list-item>
            </template>
            <template v-for="(subitem, subIndex) in item.children">
              <v-list-item
                v-if="!subitem.restriction || subitem.restriction()"
                :id="item.id"
                :key="subIndex"
                :to="subitem.to"
                tag="router-link"
                :class="!$store.getters.isSidebarExpanded ? 'child-item child-item-indent' : 'child-item'">
                <v-list-item-icon>
                  <v-icon color="sidebarChildLink">{{ subitem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title :style="`color: ${$vuetify.theme.themes.light.sidebarChildLink}`">{{
                    subitem.title
                  }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list-group>
          <!-- ITEMS WITHOUT CHILDREN -->
          <v-list-item
            v-else
            :id="item.id"
            :key="index"
            :to="item.to"
            tag="router-link"
            class="parent-item">
            <v-list-item-icon>
              <v-icon color="sidebarLink">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title :style="`color: ${$vuetify.theme.themes.light.sidebarLink}`">{{
                item.title
              }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </template>
    </v-list>
    <!--BOTTOM SHEET-->
    <div style="position:absolute;bottom:0;width:100%">
      <v-divider></v-divider>
      <v-list>
        <v-list-item class="justify-center">
          <DeveloperTools/>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon class="v-chip--clickable" @click.stop="$store.commit('toggleSidebar')">
            <v-icon v-if="!$store.getters.isSidebarExpanded" color="sidebarLink">mdi-chevron-double-left</v-icon>
            <v-icon v-else color="sidebarLink">mdi-chevron-double-right</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="v-chip--clickable" @click="$router.push('/changelog')">
            <small :style="`color: ${tinycolor($vuetify.theme.themes.light.sidebarLink).darken(30).toHexString()}`">Version:
              {{ $store.getters.appVersion }}</small>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<style scoped>
.sidebar-logo-container {
  height: 64px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)
}
</style>
